export default "__VITE_ASSET__BQAVwvVq__"